module.exports = __webpack_public_path__ + "static/img/bg.f346b2be.png";